// Module
var code = `<a
  data-channel="ROUTE"
  data-page-id="{{menuData.pageId}}"
  data-stage="{{menuData.stage}}"
  data-section="{{menuData.section}}"
  data-topic="{{menuData.topic}}"
  data-subtopic="{{menuData.subtopic}}"
  data-event-prevent-default="true"
  class="breadcrumb-link"
  href="{{url}}"
  >{{menuLabel}}</a
>
`;
// Exports
module.exports = code;